import submit from "submit-form";
import Avatar from "../parts/avatar";
import SvgIcon from "./SvgIcon";
import { useEffect, useRef, useState } from "react";
import useClickOutside from "../hooks/useClickOutside";
import { isPullActiveCoach } from "../utils/user-helpers";
import { getUserAccess } from "../utils/organization-helpers";

const HeaderProfile = ({
  activeUser,
  isAdmin,
  locals,
  activeUserToRequest,
  daysLeft,
}) => {
  const [opened, setOpened] = useState(false);
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setOpened(false);
    },
    opened
  );
  const userIsCoach = activeUser.permissions.includes("coach");
  const { link: referralLink = "" } = activeUser.referralProgramInfo || {};
  const userHasCustomReferralLink = referralLink.length > 0;
  const referralProgramLinkInfo = {
    referralLinkname: userHasCustomReferralLink
      ? "Referral Program"
      : "Referral Program Link",
    hideReferralLinkIcon: userHasCustomReferralLink,
    referralLinkUrl: !userHasCustomReferralLink
      ? "https://mystrengthbook.firstpromoter.com/"
      : "/actions/refresh?modal[type]=referral-link-program",
  };
  const { referralLinkname, hideReferralLinkIcon, referralLinkUrl } =
    referralProgramLinkInfo;
  const isCoachingPortal = Boolean(
    locals?.pathname?.includes("coaching-portal")
  );
  const userIsPressCoach =
    (!activeUser.organizationId && !locals.organizationOwner) || !userIsCoach
      ? Boolean(activeUser.pressAccountInfo)
      : Boolean(locals.organizationOwner.pressAccountInfo);

  const userIsPushCoach = getUserAccess(
    activeUser,
    locals.organizationOwner,
    locals.organizationPermissions,
    locals.organizationRoles
  ).userCanAccessToPush;

  const showPullButton = userIsCoach && !isPullActiveCoach(activeUser);
  const showPushButton = userIsCoach && !userIsPushCoach;
  const showPressButton = userIsCoach && !userIsPressCoach;
  const isPullCoachOnTrial =
    activeUserToRequest.coachingFreeTrial && daysLeft > 0;
  const isPushCoachWithEndedTrial =
    activeUserToRequest.permissions.includes("coach") &&
    activeUserToRequest.pushAccountInfo &&
    daysLeft < 1 &&
    !isPullActiveCoach(activeUserToRequest);
  useEffect(() => {
    //get details element
    const details = document.getElementById("profile-dropdown");
    //check if open attribute is not present
    if (!details.hasAttribute("open")) {
      console.log("setting open attribute to true");
      //set open attribute to true
      details.setAttribute("open", true);
    }
  }, []);
  return (
    <>
      <details open={true} ref={dropdownRef} id="profile-dropdown" role="list">
        <summary
          aria-haspopup="listbox"
          onClick={(e) => {
            console.log("clicked");
            e.preventDefault();
            setOpened(!opened);
          }}
        >
          <Avatar size={"2.5"} unit="rem" />
          <div className="mobile-hidden">{activeUser.name}</div>
          <SvgIcon src={`/img/svg/angle-${opened ? "up" : "down"}.svg`} />
        </summary>
        <div className={opened ? "opened" : undefined}>
          <fieldset>
            <legend>Account</legend>
            <ul>
              <li>
                <a
                  onClick={() => setOpened(false)}
                  href="/coaching-portal/settings/profile"
                  role="button"
                  data-button-type="text-white"
                  data-icon
                >
                  <SvgIcon src="/img/new-icons/profile-circle.svg" />
                  Edit Profile
                </a>
              </li>
              {userIsCoach && (
                <>
                  <li>
                    <a
                      onClick={() => setOpened(false)}
                      href="/coaching-portal/settings/manage-coaches?organizationInviteCoach=true"
                      role="button"
                      data-button-type="text-white"
                      data-icon
                    >
                      <SvgIcon src="/img/new-icons/profile-circle.svg" />
                      Invite New Coach
                    </a>
                  </li>
                  {isCoachingPortal && (
                    <li>
                      <a
                        className="anchor-with-two-icons"
                        onClick={() => setOpened(false)}
                        role="button"
                        data-button-type="text-white"
                        data-icon
                        href={referralLinkUrl}
                        target={
                          !userHasCustomReferralLink ? "_blank" : undefined
                        }
                        rel={
                          !userHasCustomReferralLink
                            ? "noopener noreferrer"
                            : undefined
                        }
                      >
                        <div className="header-element-icon-text-icon">
                          <SvgIcon src="/img/new-icons/vuesax-linear-share.svg" />
                          <p>{referralLinkname}</p>
                        </div>
                        {!hideReferralLinkIcon && (
                          <SvgIcon src="/img/new-icons/export.svg" />
                        )}
                      </a>
                    </li>
                  )}
                </>
              )}
            </ul>
          </fieldset>
          {userIsCoach && (
            <>
              <fieldset>
                <legend>Billing</legend>
                {isPullCoachOnTrial || isPushCoachWithEndedTrial ? (
                  <a
                    href="/coach-billing"
                    role="button"
                    data-button-type="secondary"
                    className="my-3"
                  >
                    <span className="clipped font-semibold">Upgrade Now</span>
                  </a>
                ) : (
                  <ul>
                    <li>
                      <a
                        onClick={() => setOpened(false)}
                        href="/coaching-portal/settings/coach-manage-billing"
                        role="button"
                        data-button-type="text-white"
                        data-icon
                      >
                        <SvgIcon src="/img/new-icons/card.svg" />
                        Manage Billing
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setOpened(false)}
                        href="/coaching-portal/settings/coach-billing"
                        role="button"
                        data-button-type="text-white"
                        data-icon
                      >
                        <SvgIcon src="/img/new-icons/profile-circle.svg" />
                        Coach Billing
                      </a>
                    </li>
                  </ul>
                )}
              </fieldset>
              <fieldset>
                <legend>Products</legend>
                <ul>
                  <li>
                    <a
                      onClick={() => setOpened(false)}
                      role="button"
                      data-button-type="text-white"
                      data-icon
                      href="https://mystrengthbook.canny.io/feature-requests"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <p>Feature Request</p>
                      <SvgIcon src="/img/new-icons/export.svg" />
                    </a>
                  </li>
                  {showPullButton && (
                    <li>
                      <a
                        onClick={() => setOpened(false)}
                        role="button"
                        data-button-type="text-white"
                        data-icon
                        href="https://mystrengthbook.com/pull/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p>
                          Upgrade to PULL <span> (Coaching)</span>
                        </p>

                        <SvgIcon src="/img/new-icons/export.svg" />
                      </a>
                    </li>
                  )}
                  {showPushButton && (
                    <li>
                      <a
                        onClick={() => setOpened(false)}
                        role="button"
                        data-button-type="text-white"
                        data-icon
                        href="https://form.typeform.com/to/jOPku6ra"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p>
                          Request PUSH access <span> (Subscriptions)</span>
                        </p>
                        <SvgIcon src="/img/new-icons/export.svg" />
                      </a>
                    </li>
                  )}
                  {showPressButton && (
                    <li>
                      <a
                        onClick={() => setOpened(false)}
                        role="button"
                        data-button-type="text-white"
                        data-icon
                        href="https://form.typeform.com/to/jOPku6ra"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p>
                          Request PRESS access <span> (Gym Management)</span>
                        </p>
                        <SvgIcon src="/img/new-icons/export.svg" />
                      </a>
                    </li>
                  )}
                </ul>
              </fieldset>
            </>
          )}

          {isAdmin && (
            <fieldset>
              <legend>Admin</legend>
              <ul>
                <li>
                  <a
                    onClick={() => setOpened(false)}
                    role="button"
                    data-button-type="text-white"
                    data-icon
                    href="/admin/users"
                  >
                    <SvgIcon src="/img/new-icons/layer-group.svg" />
                    Console
                  </a>
                </li>
              </ul>
            </fieldset>
          )}
          <fieldset>
            <legend>Support</legend>
            <ul>
              <li>
                <a
                  onClick={() => setOpened(false)}
                  role="button"
                  data-button-type="text-white"
                  data-icon
                  href={
                    userIsCoach
                      ? "/coaching-portal/support/contact"
                      : "/dashboard/support/contact"
                  }
                >
                  <SvgIcon src="/img/new-icons/call.svg" />
                  Contact us
                </a>
              </li>
            </ul>
          </fieldset>
          <a role="button" href="/logout">
            Logout
          </a>
        </div>
      </details>
    </>
  );
};

const onSubmit = (e) => {
  e.preventDefault();
  submit(`/actions/refresh`, {
    method: "GET",
    body: { name: e.target.name.value },
  });
};

const AthleteFinder = ({ handleShowFinder = () => {}, mobile = false }) => (
  <form onSubmit={onSubmit}>
    <input role="submit-athlete-search" type="submit" value="" />
    <input
      type="search"
      name="name"
      placeholder={`Search...`}
      defaultValue={""}
    />
    {mobile && (
      <button onClick={handleShowFinder}>
        <img src="/img/svg/close.svg" alt="close" />
      </button>
    )}
  </form>
);

export { HeaderProfile, AthleteFinder };
